import { render, staticRenderFns } from "./GoodsVisitViewPanel.vue?vue&type=template&id=fb28b88e"
import script from "./GoodsVisitViewPanel.vue?vue&type=script&lang=js"
export * from "./GoodsVisitViewPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports